export const hi = {
  // Common
  "common.back": "वापस",
  "common.cancel": "रद्द करें",
  "common.noItems": "कोई आइटम नहीं",
  "common.loading": "लोड हो रहा है...",
  
  // Header
  "nav.features": "विशेषताएं",
  "nav.howItWorks": "यह कैसे काम करता है",
  "nav.pricing": "मूल्य निर्धारण",
  "nav.faq": "अक्सर पूछे जाने वाले प्रश्न",
  "nav.testimonials": "प्रदर्शनी",
  "nav.contact": "संपर्क",
  "button.getStarted": "शुरू करें",
  "button.loading": "लोड हो रहा है...",

  // Auth related
  "auth.signIn": "साइन इन करें",
  "auth.redirecting": "रीडायरेक्ट हो रहा है...",
  "auth.continueWithGoogle": "Google के साथ जारी रखें",
  "auth.continueWithGithub": "GitHub के साथ जारी रखें",
  "auth.or": "या",
  "auth.consent.prefix": "जारी रखकर, आप हमारे",
  "auth.consent.terms": "नियमों",
  "auth.consent.and": "और",
  "auth.consent.privacy": "गोपनीयता नीति",

  // Site Title
  "site.title": "Communicate to Win",
  "site.title.first": "Communicate",
  "site.title.second": "to Win",
  "site.title.translated": "沟通制胜",

  // Hero Section
  "hero.title": "AI-संचालित संचार सहायक",
  "hero.subtitle": "बुद्धिमान, संदर्भ-जागरूक प्रतिक्रियाओं के साथ अपनी बातचीत को बदलें जो आपको किसी भी स्थिति में अधिक प्रभावी रूप से संवाद करने में मदद करती हैं।",
  "hero.cta.primary": "निःशुल्क परीक्षण शुरू करें",
  "hero.cta.secondary": "डेमो देखें",
  "hero.cta.tryNow": "निःशुल्क शुरू करें",
  "hero.cta.learnMore": "और जानें",
  "hero.cta.getStarted": "निःशुल्क शुरू करें",
  "hero.preview.primary": "टोन पॉलिश करें",
  "hero.preview.secondary": "अनुवाद करें",
  "hero.preview.tone": "मैत्रीपूर्ण",
  "hero.preview.target": "ग्राहक",
  "hero.hook": "हर दिन अपना संचार सुधारने वाले हजारों उपयोगकर्ताओं के साथ जुड़ें।",
  "hero.headline": "AI-संचालित संचार सहायक",
  "hero.subheadline": "अस्पष्ट विचारों को सेकंडों में पॉलिश और संदर्भ-जागरूक प्रतिक्रियाओं में बदलें।",
  
  // Stats
  "stats.users": "उपयोगकर्ता",
  "stats.replies": "प्रतिक्रियाएं",
  "stats.languages": "भाषाएँ",

  // Main Title
  "main.title": "हर उत्तर को एक अवसर में बदलें",

  // Footer Section
  "footer.company": "कंपनी",
  "footer.product": "उत्पाद",
  "footer.support": "सहायता",
  "footer.legal": "कानूनी",
  "footer.contactSupport": "सहायता से संपर्क करें",
  "footer.helpCenter": "सहायता केंद्र",
  "footer.apiDocs": "API दस्तावेज़",
  "footer.statusPage": "स्थिति पृष्ठ",
  "footer.privacyPolicy": "गोपनीयता नीति",
  "footer.termsOfService": "सेवा की शर्तें",
  "footer.cookiePolicy": "कुकी नीति",
  "footer.refundPolicy": "वापसी नीति",
  "footer.copyright": "© 2025 DOUBLEWIND LTD. All rights reserved.",
  "footer.supportLabel": "सहायता",

  // Features Section
  "features.badge": "शक्तिशाली विशेषताएं",
  "features.title": "बेहतर संचार के लिए आपको जो कुछ भी चाहिए",
  "features.subtitle": "व्यापक उपकरण जो हर बातचीत को अधिक प्रभावी और पेशेवर बनाने के लिए डिज़ाइन किए गए हैं।",
  "features.scenario.title": "परिदृश्य टेम्प्लेट",
  "features.scenario.description": "कार्यक्षेत्र, व्यक्तिगत, शैक्षणिक और पेशेवर संचार के लिए पूर्व-निर्मित टेम्प्लेट।",
  "features.custom.title": "कस्टम इनपुट",
  "features.custom.description": "कोई भी संदेश या सामग्री पेस्ट करें और संदर्भ के अनुकूल उपयुक्त प्रतिक्रियाएं प्राप्त करें।",
  "features.instant.title": "उत्तर समय 90% कम करें",
  "features.instant.description": "कुछ सेकंड में AI-निर्मित उत्तर प्राप्त करें। कोई प्रतीक्षा नहीं, केवल परिणाम।",
  "features.copy.title": "वन-क्लिक कॉपी और साझा करें",
  "features.copy.description": "तुरंत प्रतिक्रियाओं को कॉपी करें या उन्हें सीधे प्लेटफॉर्म से साझा करें।",

  // How It Works Section
  "howItWorks.badge": "यह कैसे काम करता है",
  "howItWorks.title": "बेहतर संचार के लिए तीन सरल चरण",
  "howItWorks.subtitle": "हमारी सुव्यवस्थित प्रक्रिया किसी भी स्थिति के लिए पेशेवर प्रतिक्रियाएं उत्पन्न करना आसान बनाती है।",
  "howItWorks.step1.title": "परिदृश्य चुनें",
  "howItWorks.step1.description": "संचार परिदृश्य चुनें जो आपकी आवश्यकताओं के लिए सबसे उपयुक्त हो।",
  "howItWorks.step2.title": "सामग्री पेस्ट करें",
  "howItWorks.step2.description": "संदेश या सामग्री जोड़ें जिसका आपको उत्तर देना है।",
  "howItWorks.step3.title": "AI प्रतिक्रिया प्राप्त करें",
  "howItWorks.step3.description": "सेकंडों में एक पेशेवर, संदर्भित प्रतिक्रिया प्राप्त करें।",

  // Pricing Section
  "pricing.title": "मूल्य निर्धारण",
  "pricing.subtitle": "अपनी संचार आवश्यकताओं के अनुकूल योजना चुनें",
  "pricing.plan.free": "Free",
  "pricing.plan.pro": "Pro",
  "pricing.plan.business": "Enterprise",
  "pricing.free.price": "$0",
  "pricing.pro.price": "$9.99",
  "pricing.business.price": "$29.99",
  "pricing.period": "/महीना",
  "pricing.free.description": "हमारी सेवा आज़माने के लिए बिल्कुल सही",
  "pricing.pro.description": "पेशेवरों और बार-बार उपयोग करने वालों के लिए आदर्श",
  "pricing.business.description": "टीमों और संगठनों के लिए",
  "pricing.popular": "सबसे लोकप्रिय",
  "pricing.free.feature1": "प्रति माह 10 उत्तर",
  "pricing.free.feature2": "बुनियादी परिदृश्य",
  "pricing.free.feature3": "टेम्प्लेट परिभाषित और उपयोग करें",
  "pricing.free.feature4": "ऐतिहासिक उत्तर रिकॉर्ड",
  "pricing.pro.feature1": "प्रति माह 200 उत्तर",
  "pricing.pro.feature2": "बुनियादी+कस्टम परिदृश्य",
  "pricing.pro.feature3": "टेम्प्लेट परिभाषित और उपयोग करें",
  "pricing.pro.feature4": "ऐतिहासिक उत्तर रिकॉर्ड",
  "pricing.pro.feature5": "उन्नत अनुकूलन",
  "pricing.business.feature1": "असीमित उत्तर",
  "pricing.business.feature2": "टीम सहयोग",
  "pricing.business.feature3": "बुनियादी+कस्टम परिदृश्य",
  "pricing.business.feature4": "टेम्प्लेट परिभाषित और उपयोग करें",
  "pricing.business.feature5": "ऐतिहासिक उत्तर रिकॉर्ड",
  "pricing.business.feature6": "उन्नत अनुकूलन",
  "pricing.cta.trial": "निःशुल्क परीक्षण शुरू करें",
  "pricing.cta.subscribe": "सदस्यता लें",
  "pricing.cta.contact": "बिक्री से संपर्क करें",
  "pricing.cta.current": "वर्तमान योजना",
  "pricing.currentPlan": "वर्तमान योजना:",
  "pricing.endDate": "वर्तमान योजना समाप्ति तिथि:",
  "pricing.autoRenewalDate": "वर्तमान योजना स्वचालित नवीकरण तिथि:",
  "pricing.answersLeft": "शेष उत्तर:",
  "pricing.planName.free": "Free योजना",
  "pricing.planName.proMonthly": "Pro योजना-मासिक",
  "pricing.planName.proYearly": "Pro योजना-वार्षिक",
  "pricing.planName.maxMonthly": "Enterprise योजना-मासिक",
  "pricing.planName.maxYearly": "Enterprise योजना-वार्षिक",
  "pricing.autoRenews": "आपके उत्तरों की गिनती स्वचालित रूप से नवीकृत होती है:",
  "pricing.needMore": "अधिक उत्तरों की आवश्यकता है?",
  "pricing.upgradeBelow": "नीचे अपनी योजना को अपग्रेड करें",
  "pricing.doNotRollOver": "अप्रयुक्त उत्तर आगे नहीं बढ़ते",
  "pricing.willCancelOn": "रद्द होगा:",
  "pricing.downgradeScheduled": "डाउनग्रेड निर्धारित। इसमें बदल जाएगा",
  "pricing.on": "पर:",
  "pricing.upgradeImmediateTitle": "योजना अपग्रेड की गई",
  "pricing.upgradeImmediateDesc": "आपकी नई योजना अब सक्रिय है।",
  "pricing.downgradeScheduledTitle": "डाउनग्रेड निर्धारित",
  "pricing.downgradeScheduledDesc": "आपकी योजना अगले नवीकरण पर बदल जाएगी।",
  "pricing.cancelScheduledTitle": "रद्दीकरण निर्धारित",
  "pricing.cancelScheduledDesc": "आपकी योजना अवधि के अंत में समाप्त हो जाएगी।",
  "pricing.cancelResumedTitle": "रद्दीकरण हटा दिया गया",
  "pricing.cancelResumedDesc": "आपकी सदस्यता नवीकृत होती रहेगी।",
  "pricing.cancelPendingDowngrade": "रद्द करें",
  "pricing.pendingDowngradeCanceledTitle": "लंबित डाउनग्रेड रद्द किया गया",
  "pricing.pendingDowngradeCanceledDesc": "आपकी योजना अपरिवर्तित रहेगी।",
  "pricing.pendingDowngradeCancelFailedTitle": "रद्द करना विफल रहा",
  "pricing.pendingDowngradeCancelFailedDesc": "लंबित डाउनग्रेड रद्द नहीं किया जा सका। कृपया पुनः प्रयास करें।",
  "pricing.cancelPendingDowngradeProcessing": "प्रसंस्करण...",
  "pricing.scheduled": "निर्धारित",
  "pricing.processing": "प्रसंस्करण...",
  "pricing.getMoreReplies": "अधिक उत्तर प्राप्त करें",
  "pricing.oneTimeTitle": "अपने खाते के लिए अधिक उत्तर प्राप्त करें",
  "pricing.oneTimeAmountLabel": "राशि (USD)",
  "pricing.repliesUnit": "उत्तर",
  "pricing.oneTimeNotice": "आपके द्वारा खरीदे गए उत्तरों की संख्या वर्तमान मासिक चक्र के लिए मान्य है। उनका उपयोग करने के लिए एक सक्रिय भुगतान सदस्यता की आवश्यकता होती है, और अप्रयुक्त उत्तर आगे नहीं बढ़ते।",
  "pricing.cancel": "रद्द करें",
  "pricing.proceed": "आगे बढ़ें",
  "pricing.confirmUpgradeTitle": "अपग्रेड की पुष्टि करें",
  "pricing.confirmDowngradeTitle": "डाउनग्रेड की पुष्टि करें",
  "pricing.confirmUpgradeDesc": "आप अपनी योजना को अपग्रेड करने वाले हैं। परिवर्तन तुरंत प्रभावी होता है और आनुपातिक शुल्क (या क्रेडिट) लागू हो सकता है।",
  "pricing.confirmDowngradeDesc": "आप डाउनग्रेड निर्धारित करने वाले हैं। आपकी वर्तमान सुविधाएं वर्तमान बिलिंग अवधि के अंत तक रहती हैं।",
  "pricing.downgradeEffectNote": "डाउनग्रेड वर्तमान चक्र की धनवापसी नहीं करता है।",
  "pricing.downgradeApplyNextCycle": "नई योजना नवीकरण पर स्वचालित रूप से शुरू हो जाएगी।",
  "pricing.confirmCancel": "वापस",
  "pricing.confirmProceedUpgrade": "अभी अपग्रेड करें",
  "pricing.confirmProceedDowngrade": "डाउनग्रेड निर्धारित करें",

  // FAQ Section
  "faq.title": "अक्सर पूछे जाने वाले प्रश्न",
  "faq.subtitle": "communicate2win के बारे में जो कुछ भी आपको जानना चाहिए",
  "faq.q1": "कौन से संचार परिदृश्य समर्थित हैं?",
  "faq.a1": "हम कार्यक्षेत्र संचार, व्यक्तिगत संबंध, शैक्षणिक पत्राचार, ग्राहक सेवा, बिक्री पहुंच और कई अन्य परिदृश्यों का समर्थन करते हैं। हमारा AI प्रत्येक स्थिति के लिए आवश्यक संदर्भ और टोन के अनुकूल होता है।",
  "faq.q2": "प्रतिक्रियाएं कितनी तेज़ी से उत्पन्न होती हैं?",
  "faq.a2": "हमारा AI कुछ सेकंड में प्रतिक्रियाएं उत्पन्न करता है। हम गुणवत्ता से समझौता किए बिना गति को प्राथमिकता देते हैं, यह सुनिश्चित करते हुए कि आपको तुरंत पेशेवर प्रतिक्रियाएं मिलें।",
  "faq.q3": "क्या मैं अपनी सदस्यता कभी भी रद्द कर सकता हूं?",
  "faq.a3": "हां, आप अपनी सदस्यता कभी भी रद्द कर सकते हैं। कोई दीर्घकालिक प्रतिबद्धताएं नहीं हैं, और आप आवश्यकता के अनुसार अपनी योजना को डाउनग्रेड या अपग्रेड कर सकते हैं।",
  "faq.q4": "क्या मेरा डेटा सुरक्षित और निजी है?",
  "faq.a4": "हां, हम एन्क्रिप्शन, एक्सेस कंट्रोल और नियमित सुरक्षा ऑडिट सहित व्यापक सुरक्षा उपाय लागू करते हैं। आपकी इनपुट सामग्री और उत्पन्न प्रतिक्रियाएं प्रतिक्रिया समीक्षा और टेम्प्लेट निर्माण जैसी सुविधाओं को सक्षम करने के लिए आपके उपयोगकर्ता इतिहास के हिस्से के रूप में संग्रहीत होती हैं। आप अपनी खाता सेटिंग्स के माध्यम से कभी भी अपना इतिहास डेटा हटा सकते हैं।",
  "faq.q5": "अगर मेरी Replies खत्म हो जाएँ तो क्या करूँ?",
  "faq.a5": "Free उपयोगकर्ताओं को अपना कोटा रिफ्रेश होने के लिए अगले मासिक चक्र तक इंतज़ार करना होगा। Pro में अपग्रेड करने के बाद यदि Replies कम पड़ जाएँ तो आप अतिरिक्त एकमुश्त Replies खरीद सकते हैं; ये अतिरिक्त Replies केवल वर्तमान मासिक चक्र के लिए मान्य होती हैं। Enterprise उपयोगकर्ताओं के पास असीमित Replies होती हैं।",
  "faq.q6": "कौन सी भाषाएं समर्थित हैं?",
  "faq.a6": "वर्तमान में, हम अंग्रेजी का समर्थन करते हैं और स्पेनिश, फ्रेंच, जर्मन और अन्य प्रमुख भाषाओं में विस्तार की योजना बना रहे हैं। AI बहुभाषी संचार को प्रभावी रूप से संभाल सकता है।",

  // Testimonials Section
  "testimonials.title": "संचार प्रदर्शनी",
  "testimonials.subtitle": "सार्वजनिक संदेश, ईमेल और AI-पॉलिश्ड प्रतिक्रियाएं आपकी खुद की प्रेरणा के लिए",
  "testimonials.sarah.name": "सारा जॉनसन",
  "testimonials.sarah.title": "मार्केटिंग निदेशक",
  "testimonials.sarah.quote": "communicate2win ने मेरे ग्राहक संचार को संभालने के तरीके को बदल दिया है। प्रतिक्रियाएं पेशेवर हैं और हर सप्ताह मेरे घंटों की बचत करती हैं।",
  "testimonials.michael.name": "माइकल चेन",
  "testimonials.michael.title": "बिक्री प्रबंधक",
  "testimonials.michael.quote": "कार्यक्षेत्र परिदृश्य टेम्प्लेट अविश्वसनीय रूप से सटीक हैं। इस उपकरण का उपयोग करने के बाद से मेरी प्रतिक्रिया दर में 40% सुधार हुआ है।",
  "testimonials.emily.name": "एमिली रॉड्रिगेज",
  "testimonials.emily.title": "ग्राहक सफलता प्रमुख",
  "testimonials.emily.quote": "कठिन ग्राहक स्थितियों को संभालने के लिए बिल्कुल सही। AI संदर्भ और टोन को पूर्ण रूप से समझता है।",
  "testimonials.more": "पूरी प्रदर्शनी का अन्वेषण करने के लिए गैलरी पर क्लिक करें",

  // Interface Elements
  "interface.generating": "प्रतिक्रिया उत्पन्न हो रही है...",
  "interface.generate": "AI प्रतिक्रिया उत्पन्न करें",
  "interface.processing": "प्रसंस्करण...",
  "interface.advancedOptions": "उन्नत विकल्प",
  "interface.clearInput": "इनपुट साफ़ करें",
  "interface.clearDescription": "विवरण साफ़ करें",
  // Marquee / Logos
  "marquee.trusted": "साझेदार / समर्थन",
  "marquee.aria": "ब्रांड लोगो",

  // History and Showcase
  "history.shareToShowcase": "प्रदर्शनी में साझा करें",
  "history.showcased": "प्रदर्शित",
  "history.shareConfirm": "इस पोस्ट को प्रदर्शनी में साझा करें? यह क्रिया तब तक पूर्ववत नहीं हो सकती जब तक आप पोस्ट को हटा न दें।",
  "history.sharedBy": "द्वारा साझा किया गया:",
  "interface.copy": "कॉपी करें",
  "interface.share": "साझा करें",
  "interface.shareResponse": "प्रतिक्रिया साझा करें",
  "interface.shareNative": "सिस्टम के माध्यम से साझा करें",
  "interface.shareEmail": "ईमेल",
  "interface.copyShareText": "लिंक के साथ कॉपी करें",
  "interface.shareTextCopied": "प्रतिक्रिया और लिंक क्लिपबोर्ड में कॉपी किए गए।",
  "interface.ready": "उत्पन्न करने के लिए तैयार",
  "interface.enterMessage": "अपना संदेश सामग्री दर्ज करें और AI-संचालित प्रतिक्रियाओं के साथ शुरू करने के लिए एक परिदृश्य चुनें।",
  "interface.fast": "तेज़",
  "interface.accurate": "सटीक",
  "interface.professional": "पेशेवर",
  "interface.translation": "अनुवाद",
  "interface.responseDescription": "यहां संदर्भ के अनुकूल एक विचारशील और पेशेवर प्रतिक्रिया है:",
  "interface.multipleOptions": "कई प्रतिक्रिया विकल्प:",
  "interface.option": "विकल्प",
  "interface.noContent": "कोई सामग्री उपलब्ध नहीं",

  // Placeholders
  "placeholder.message": "संदेश पेस्ट करें जिसका आप उत्तर दे रहे हैं, ईमेल सामग्री या आपको प्राप्त पाठ...",

  // Dropdowns
  "dropdown.useTemplates": "टेम्प्लेट का उपयोग करें",
  "dropdown.scenario": "कोई परिदृश्य नहीं",
  "dropdown.target": "कोई लक्ष्य नहीं",
  "dropdown.tone": "कोई टोन नहीं",

  // Scenario Options
  "scenario.email": "ईमेल",
  "scenario.message": "संदेश",
  "scenario.workplace": "कार्यक्षेत्र",
  "scenario.school": "स्कूल",
  "scenario.home": "घर",
  "scenario.business": "व्यवसाय",
  "scenario.academic": "शैक्षणिक",
  "scenario.social": "सामाजिक",
  "scenario.formal": "औपचारिक",
  "scenario.casual": "अनौपचारिक",
  "scenario.professional": "पेशेवर",
  "scenario.personal": "व्यक्तिगत",
  "scenario.customerService": "ग्राहक सेवा",
  "scenario.interview": "साक्षात्कार",
  "scenario.presentation": "प्रस्तुति",

  // Target Options
  "target.lover": "प्रेमी",
  "target.friend": "मित्र",
  "target.boss": "बॉस",
  "target.colleague": "सहकर्मी",
  "target.classmate": "सहपाठी",
  "target.parents": "माता-पिता",
  "target.child": "बच्चा",
  "target.teacher": "शिक्षक",
  "target.student": "छात्र",
  "target.client": "ग्राहक",
  "target.customer": "ग्राहक",
  "target.stranger": "अजनबी",
  "target.family": "परिवार",
  "target.sibling": "भाई-बहन",
  "target.neighbor": "पड़ोसी",
  "target.mentor": "गुरु",
  "target.supplier": "आपूर्तिकर्ता",
  "target.serviceProvider": "सेवा प्रदाता",
  "target.partner": "साझेदार",
  "target.subordinate": "अधीनस्थ",

  // Tone Options
  "tone.humorous": "हास्यप्रद",
  "tone.serious": "गंभीर",
  "tone.happy": "खुश",
  "tone.angry": "गुस्से में",
  "tone.mischievous": "शरारती",
  "tone.polite": "विनम्र",
  "tone.casual": "अनौपचारिक",
  "tone.formal": "औपचारिक",
  "tone.friendly": "मित्रवत",
  "tone.confident": "आत्मविश्वासी",
  "tone.apologetic": "क्षमाप्रार्थी",
  "tone.enthusiastic": "उत्साही",

  // Status Messages
  "status.copied": "कॉपी किया गया!",
  "status.copyDescription": "प्रतिक्रिया क्लिपबोर्ड में कॉपी की गई।",
  "status.copyWithTranslationDescription": "प्रतिक्रिया और अनुवाद क्लिपबोर्ड में कॉपी किए गए।",
  "status.success": "प्रतिक्रिया सफलतापूर्वक उत्पन्न हुई। ",
  "status.successWithTranslation": "अनुवाद के साथ प्रतिक्रिया उत्पन्न हुई।",
  "status.successWithoutTranslation": "प्रतिक्रिया सफलतापूर्वक उत्पन्न हुई।",
  "status.error": "उत्पन्न करना असफल",
  "status.errorDescription": "प्रतिक्रिया उत्पन्न करने में असफल। कृपया पुनः प्रयास करें।",
  "status.enterContent": "कृपया सामग्री दर्ज करें",
  "status.enterContentDescription": "संदेश जोड़ें जिसका आप उत्तर देना चाहते हैं।",

  // Pro/Max subscriber restrictions
  "restriction.descriptionOptional": "विवरण (वैकल्पिक)",
  "restriction.descriptionLabel": "विवरण (केवल Pro / Enterprise सदस्यों के लिए)",
  "restriction.proMaxOnly": "* केवल Pro / Enterprise सदस्यों के लिए",
  "restriction.desPrompt": "संदर्भ, पृष्ठभूमि जानकारी या विशिष्ट आवश्यकताएं दर्ज करें जो बेहतर प्रतिक्रियाएं उत्पन्न करने में मदद कर सकती हैं...",

  // Demo functionality for non-logged-in users
  "demo.title": "उत्तर देने के लिए एक संदेश चुनें",
  "demo.option1": "बिक्री शुरुआत (कोल्ड आउटरीच)",
  "demo.option2": "\"आपकी कीमत अधिक है\" जांच को संभालना",
  "demo.option3": "साक्षात्कार स्व-परिचय (30-सेकंड संस्करण)",
  "demo.option4": "ईमेल उत्तर",
  "demo.option5": "\"पढ़ा-लेकिन-कोई-उत्तर-नहीं\" संभावना के लिए फॉलो-अप",
  "demo.option6": "एलिवेटर पिच (30 सेकंड)",
  "demo.runDemo": "डेमो चलाएं",
  "demo.inputContent": "इनपुट सामग्री:",
  "demo.scenario": "परिदृश्य:",
  "demo.target": "लक्ष्य:",
  "demo.tone": "टोन:",
  "demo.description": "विवरण:",

  // Showcase Page
  "showcase.title": "संचार प्रदर्शनी",
  "showcase.subtitle": "हमारे समुदाय द्वारा साझा किए गए प्रेरक AI-संचालित संचार की खोज करें",
  "showcase.userPrefix": "द्वारा सार्वजनिक संचार",
  "showcase.backAll": "पूरी प्रदर्शनी पर वापस जाएं",
  "showcase.sortBy": "द्वारा क्रमबद्ध करें:",
  "showcase.sort.newest": "नवीनतम पहले",
  "showcase.sort.oldest": "सबसे पुराना पहले",
  "showcase.sort.scenario": "परिदृश्य द्वारा",
  "showcase.sort.target": "लक्ष्य द्वारा",
  "showcase.sort.tone": "टोन द्वारा",
  "showcase.filter.scenario": "परिदृश्य:",
  "showcase.filter.target": "लक्ष्य:",
  "showcase.filter.tone": "टोन:",
  "showcase.filter.all": "सभी",
  "showcase.loading": "प्रदर्शनी लोड हो रही है...",
  "showcase.loadingUser": "उपयोगकर्ता संचार लोड हो रहा है...",
  "showcase.loadingMore": "अतिरिक्त लोड हो रहा है...",
  "showcase.none.userTitle": "अभी तक कोई सार्वजनिक संचार नहीं",
  "showcase.none.globalTitle": "अभी तक प्रदर्शनी आइटम नहीं",
  "showcase.none.userDesc": "इस उपयोगकर्ता ने अभी तक प्रदर्शनी में कोई संचार साझा नहीं किया है।",
  "showcase.none.globalDesc": "प्रदर्शनी में अपना पहला AI-संचार साझा करें!",
  "showcase.messageDetails": "संदेश विवरण",
  "showcase.field.date": "तारीख",
  "showcase.field.scenario": "परिदृश्य",
  "showcase.field.target": "लक्ष्य",
  "showcase.field.tone": "टोन",
  "showcase.originalMessage": "मूल संदेश",
  "showcase.description": "विवरण",
  "showcase.aiResponse": "AI प्रतिक्रिया",

  // Templates
  "templates.saveAsTemplate": "टेम्प्लेट के रूप में सहेजें",
  "templates.saved": "टेम्प्लेट सहेजा गया",
  "templates.saveSuccess": "टेम्प्लेट सफलतापूर्वक सहेजा गया",
  "templates.title": "मेरे टेम्प्लेट",
  "templates.new": "नया टेम्प्लेट",
  "templates.loading": "लोड हो रहा है...",
  "templates.none": "कोई टेम्प्लेट नहीं मिला",
  "templates.name": "नाम",
  "templates.scenario": "परिदृश्य",
  "templates.target": "लक्ष्य",
  "templates.tone": "टोन",
  "templates.description": "विवरण",
  "templates.save": "सहेजें",
  "templates.saving": "सहेजा जा रहा है...",
  "templates.delete": "टेम्प्लेट हटाएं",
  "templates.deleteConfirm": "इस टेम्प्लेट को हटाएं?",
  "templates.deleteFailed": "टेम्प्लेट हटाने में विफल",
  "templates.nameRequired": "* कृपया टेम्प्लेट नाम दर्ज करें",
  "templates.deleteSuccess": "टेम्प्लेट सफलतापूर्वक हटा दिया गया",

  // History Modal additions
  "history.messageDetails": "संदेश विवरण",
  "history.messageDetailsDesc": "मूल इनपुट और AI-उत्पन्न प्रतिक्रिया सहित संदेश विवरण देखें और प्रबंधित करें।",
  "history.field.date": "तारीख",
  "history.field.scenario": "परिदृश्य",
  "history.field.target": "लक्ष्य",
  "history.field.tone": "टोन",
  "history.originalMessage": "मूल संदेश",
  "history.aiResponse": "AI प्रतिक्रिया",
  "history.description": "विवरण",
  "history.listTitle": "संदेश इतिहास",
  "history.listDesc": "अपने संवाद इतिहास को ब्राउज़, फ़िल्टर और प्रबंधित करें। विवरण देखने के लिए किसी भी संदेश पर क्लिक करें।",
  "history.sortBy": "द्वारा क्रमबद्ध करें:",
  "history.sort.newest": "नवीनतम पहले",
  "history.sort.oldest": "सबसे पुराना पहले",
  "history.sort.scenario": "परिदृश्य द्वारा",
  "history.sort.target": "लक्ष्य द्वारा",
  "history.sort.tone": "टोन द्वारा",
  "history.filter.scenario": "परिदृश्य:",
  "history.filter.target": "लक्ष्य:",
  "history.filter.tone": "टोन:",
  "history.filter.all": "सभी",
  "history.loading": "इतिहास लोड हो रहा है...",
  "history.loadingMore": "अतिरिक्त लोड हो रहा है...",
  "history.none": "कोई संदेश नहीं मिला",
  "history.showing": "{total} संदेशों में से {current} दिखाए जा रहे हैं",
  "history.allLoaded": "सभी संदेश लोड हो गए",
  "history.scrollMore": "और अधिक के लिए नीचे स्क्रॉल करें",
  "history.loadMoreButton": "और लोड करें",
  "history.deleteMessage": "संदेश हटाएं",
  "history.deleting": "हटाया जा रहा है...",
  "history.deleteSuccess": "संदेश रिकॉर्ड सफलतापूर्वक हटा दिया गया",
  "history.deleteFailed": "संदेश रिकॉर्ड हटाने में विफल, कृपया पुनः प्रयास करें",
  "history.confirmDeleteTitle": "हटाने की पुष्टि करें",
  "history.confirmDeleteSubtitle": "यह क्रिया पूर्ववत नहीं की जा सकती",
  "history.confirmDeleteDesc": "क्या आप वाकई इस संदेश रिकॉर्ड को हटाना चाहते हैं?",
  "history.confirmDeleteAction": "हटाने की पुष्टि करें",
  "history.shareTitle": "प्रदर्शनी में साझा करें",
  "history.shareSubtitle": "इस संदेश को सार्वजनिक बनाएं",
  "history.sharing": "साझा किया जा रहा है...",
  "history.confirmShareAction": "साझा करने की पुष्टि करें",
  "history.shareSuccess": "संदेश प्रदर्शनी में सफलतापूर्वक साझा किया गया",
  "history.shareFailed": "प्रदर्शनी में साझा करने में विफल, कृपया पुनः प्रयास करें",
  "templates.saveFailed": "टेम्प्लेट सहेजने में विफल",

  // User Menu
  "userMenu.myAccount": "मेरा खाता",
  "userMenu.history": "इतिहास",
  "userMenu.templates": "टेम्प्लेट",
  "userMenu.signOut": "साइन आउट",
  
  // Hero Showcase / Demo Tabs / Previews
  "hero.preview.aiReply": "AI प्रतिक्रिया पूर्वावलोकन",
  "hero.preview.scenarioLabel": "परिदृश्य",
  // Demo short tab titles (mapped from demo option ids)
  "demo.shortTitle.salesOpener": "बिक्री शुरुआत",
  "demo.shortTitle.priceObjection": "मूल्य आपत्ति",
  "demo.shortTitle.interviewIntro": "साक्षात्कार परिचय",
  "demo.shortTitle.emailReply": "ईमेल प्रतिक्रिया",
  "demo.shortTitle.followUp": "अनुवर्ती",
  "demo.shortTitle.elevatorPitch": "एलिवेटर पिच",
  // Demo path / response overlay
  "demoTabs.pathPrefix": "डेमो",
  "demoTabs.response": "प्रतिक्रिया",
  "demoTabs.inputPrompt": "इनपुट प्रॉम्प्ट",
  "demoTabs.context": "प्रसंग",
  "demoTabs.description": "विवरण",
  "demoTabs.generate": "उत्पन्न करें",
  "demoTabs.aiOutput": "AI आउटपुट",
  "demoTabs.sample": "नमूना",
  "demoTabs.streaming": "स्ट्रीमिंग टोकन...",
  "preview.section.scenarioTemplates.title": "परिदृश्य और टेम्प्लेट",
  "preview.section.scenarioTemplates.subtitle": "त्वरित रूप से एक परिदृश्य चुनें या एक सहेजे गए टेम्प्लेट लागू करें। टेम्प्लेट विवरण/लक्ष्य/टोन पूर्व-भरण करते हैं ताकि आप उच्च-गुणवत्ता वाली पीढ़ी में तुरंत प्रवेश कर सकें।",
  "preview.section.customInputs.title": "कस्टम इनपुट",
  "preview.section.customInputs.subtitle": "कोर इनपुट + वैकल्पिक विवरण + उन्नत परिदृश्य/लक्ष्य/टोन चयनकर्ता। संदर्भ-जागरूक परिणामों के लिए स्वतंत्र रूप से संयोजन करें।",
  "preview.section.cutReplyTime.title": "उत्तर समय 90% कम करें",
  "preview.section.cutReplyTime.subtitle": "मैनुअल ड्राफ्टिंग बनाम AI सहायता की तुलना करें। समानांतर विकल्प + अंतर्निहित अनुवाद या संशोधन लूप।",
  "preview.section.copyShare.title": "वन-क्लिक कॉपी और साझा करें",
  "preview.section.copyShare.subtitle": "एकीकृत शीर्ष क्रियाओं के साथ एकाधिक विकल्प सजाया गया: सभी की प्रतिलिपि बनाएँ / साझा करें / प्रति-विकल्प प्रतिलिपि बनाएँ। अनुवाद स्वचालित रूप से संलग्न हो जाता है।",
  "preview.templates.my": "मेरे टेम्प्लेट",
  "preview.templates.new": "नया",
  "preview.manualFlow": "मैनुअल प्रवाह",
  "preview.aiAssisted": "AI सहायता प्राप्त",
  // Manual flow bullet steps
  "preview.manualFlow.step1": "संरचना और टोन की योजना बनाएं",
  "preview.manualFlow.step2": "उद्घाटन ड्राफ्ट करें / हटाएं और पुनः लिखें",
  "preview.manualFlow.step3": "विनम्रता और व्याकरण समायोजित करें",
  "preview.manualFlow.step4": "शब्दावली खोजें + अनुवाद सत्यापित करें",
  "preview.manualFlow.step5": "लक्ष्य ऐप में पेस्ट करें",
  "preview.copyAll": "सभी की प्रतिलिपि बनाएँ",
  "preview.share": "साझा करें",
  "preview.enPlusTranslation": "EN + अनुवाद",
  "preview.translationAppendNote": "(*) जब सभी की प्रतिलिपि बनाई जाती है तो अनुवाद स्वचालित रूप से संलग्न हो जाता है।",
  "preview.field.scenario": "परिदृश्य",
  "preview.field.target": "लक्ष्य",
  "preview.field.tone": "टोन",
  "preview.auto": "स्वतः",
  "preview.step.pasteOrTemplate": "अनुरोध पेस्ट करें या टेम्प्लेट चुनें",
  "preview.step.optionalDescription": "(वैकल्पिक) विवरण/परिदृश्य जोड़ें",
  "preview.step.pickOption": "उत्पन्न विकल्पों में से एक चुनें",
  "preview.step.copyShareTranslate": "वन-क्लिक कॉपी / साझा / अनुवाद करें",
  "preview.time.manual": "5–8 मिनट",
  "preview.time.ai": "30–40 सेकंड"
};